// extracted by mini-css-extract-plugin
export default {"Overlay":"ModalOverlay_Overlay__D0koC"};